/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum ContentAreaType {
  RichText = "RichText",
  FullWidth = "FullWidth",
  HalfWidth = "HalfWidth",
  TwoThirds = "TwoThirds",
  OneThird = "OneThird",
  None = "None",
}
